/* ProjectsPage.js */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Projects.css";

import Footer from "../Components/Footer";
import Modal  from "../Components/Modal";

/* ---------- media imports ---------- */
import igniteV   from "./IGHOT.mp4";
import ignite1   from "../Images/igniter/igniter-fire.png";
import ignite2   from "../Images/igniter/igniter-side.png";
import ignite3   from "../Images/igniter/igniter test.mp4";

import trailer   from "../Images/Trailer/trailer-in-action2.png";
import trailer1  from "../Images/Trailer/trailer-on-pad-1.jpeg";
import trailer2  from "../Images/Trailer/trailer_outside.png";

import engineV   from "./edited-small.mp4";
import sparrow1  from "../Images/Sparrow/engine-on-table.png";
import sparrow2  from "../Images/Sparrow/Engine Transparent.png";
import sparrow3  from "../Images/Sparrow/engine-enclosed.png";
import sparrow4  from "../Images/Sparrow/engine-fire.png";

import skipper   from "../Images/Skipper/skipper1.png";
import skipper1  from "../Images/Skipper/skipperV1.jpeg";
import skipper2  from "../Images/Skipper/electronics.jpg";

import hopper    from "../Images/hopper/hopperCAD.png";
import hopper1   from "../Images/hopper/welded.png";
import hopper2   from "../Images/hopper/in-bucket.png";
import hopper3   from "../Images/hopper/image.png";
import hopper4   from "../Images/hopper/team-photo.png";

/* ---------- helper to split long text into <p>/<br> ---------- */
const paragraphize = (txt) =>
  txt.split("\n").map((line, i) => (
    <React.Fragment key={i}>
      {line}
      <br />
    </React.Fragment>
  ));

/* ---------- long descriptions ---------- */
const engineDescriptionLong =
  "Sparrow V1 is Florida Rocket Lab’s first fully tested, student-built bi-propellant engine. "  +
  "It delivers 550 lbf at ~450 psi (IPA/N₂O) and uses a chamber–saddle–jacket design we can "  +
  'machine entirely in-house. Multiple static fires have validated the pintle injector and '  +
  'water-cooled copper chamber. Sparrow V1 is the stepping-stone to a regeneratively cooled V2 '  +
  'that will power our Hopper vehicle in the Collegiate Propulsive Lander Challenge (CPLC).';


    const trailerDescriptionLong =
    "The Test-Stand Trailer is FRL’s mobile rocket-engine laboratory. Built on a rugged steel " +
    'frame with an integrated blast wall, it carries every tank, valve, and data-acquisition  '+
    'channel needed to fire Sparrow anywhere we can tow it. Quick-change rails let us swap ' +
    'engines in hours, and a programmable control rack gives the team safe remote access to the '  +
    'system. After multiple hot-fires, the trailer will also serve as ground support for Hopper.';
  
  const igniterDescriptionLong =
    'Our torch igniter provides reliable on-demand ignition for Sparrow and future engines. '  +
    'The stable pilot flame survives high '  +
    'main-flow velocities inside the combustion chamber. With over 80 light-offs to date, the igniter is repeatable, easy '  +
    'to service, and a perfect testbed for injector R&D ahead of Sparrow V2.';
  
  const skipperDescriptionLong =
    'Skipper is a 2 feet tall vertical test article for validating GNC algorithms ahead of Hopper.'  +
    'The carbon frame carries a contra-rotating propeller stack for lift  and '  +
    'the same flight computer architecture Hopper will use. Short hop-and-hover flights let us '  +
    'tune control laws and sensor fusion in real time. Our GNC team presented the system at the '  +
    'AIAA Regional Conference, earning strong reviews for the next campaign. ';
  

    const hopperDescriptionLong =
    "Hopper is FRL’s reusable lander for the Collegiate Propulsive Lander Challenge. " +
    "Its structure, landing gear, avionics stack, and fluid systems " +
    "are all in active development, with full-vehicle tests targeted for spring 2026. " +
    "To qualify the feed system we’re building our own stainless-steel spherical propellant tanks." +
    "The first weldment was hydro-burst-tested to failure, validating the weld procedure and giving us the data we need before committing to the flight set. " +
    "This hardware path-finder keeps the program moving toward flight-ready hardware.";
  

const projects = [
  {
    title: "Sparrow Engine",
    descriptionLong: paragraphize(engineDescriptionLong),
    mediaType: "video",
    mediaUrl: engineV,
    slideImages: [sparrow1, sparrow2, sparrow3, sparrow4],
  },
  {
    title: "Trailer Testbed",
    descriptionLong: paragraphize(trailerDescriptionLong),
    mediaType: "image",
    mediaUrl: trailer,
    slideImages: [trailer1, trailer2],
  },
  {
    title: "Igniter",
    descriptionLong: paragraphize(igniterDescriptionLong),
    mediaType: "video",
    mediaUrl: igniteV,
    slideImages: [
      { type: "image", src: ignite1 },
      { type: "image", src: ignite2 },
      { type: "video", src: ignite3 },
    ],
  },
  {
    title: "Skipper",
    descriptionLong: paragraphize(skipperDescriptionLong),
    mediaType: "image",
    mediaUrl: skipper,
    slideImages: [skipper1, skipper2],
  },
  {
    title: "Hopper",
    descriptionLong: paragraphize(hopperDescriptionLong),
    mediaType: "image",
    mediaUrl: hopper,
    slideImages: [hopper1, hopper2, hopper3, hopper4],
  },
];

/* ================================================================================= */

const ProjectsPage = () => {
  /* router helpers */
  const location = useLocation();
  const navigate = useNavigate();

  /* modal state */
  const [modalOpen,       setModalOpen]       = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  /* open & close helpers */
  const openModal = (index) => {
    if (index >= 0 && index < projects.length) {
      setSelectedProject(projects[index]);
      setModalOpen(true);
    }
  };

  const closeModal = () => {
    setSelectedProject(null);
    setModalOpen(false);
  };

  /* auto-open if Homepage passed { openIndex } */
  useEffect(() => {
    const idx = location.state?.openIndex;
    if (idx !== undefined) {
      openModal(idx);
      navigate(".", { replace: true, state: {} });
    }
  }, []);

  return (
    <div>
      <div className="Hero2">
        <a className="HeroHeader2 extraSpace">Our Projects</a>
      </div>

      <div className="projects-page">
        {projects.map((prj, idx) => (
          <div
            key={idx}
            className="project-card"
            onClick={() => openModal(idx)}
          >
            {prj.mediaType === "image" && (
              <img src={prj.mediaUrl} alt={prj.title} />
            )}

            {prj.mediaType === "video" && (
            <video
                src={prj.mediaUrl}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                controls={false}
                disablePictureInPicture
                disableRemotePlayback
                style={{ pointerEvents: "none", width: "100%" }}
            />
            )}

            {prj.mediaType === "youTube" && (
              <iframe
                width="100%"
                height="auto"
                src={prj.mediaUrl}
                title={prj.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}

            <h2>{prj.title}</h2>
          </div>
        ))}
      </div>

      <Footer />
      <Modal
        isOpen={modalOpen}
        onClose={closeModal}
        project={selectedProject}
      />
    </div>
  );
};

export default ProjectsPage;
